const CARD_SCHEMES_MAP = {
  Visa: {
    value: "Visa",
    label: "Visa",
  },
  Mastercard: {
    value: "Mastercard",
    label: "MasterCard",
  },
  Amex: {
    value: "Amex",
    label: "American Express",
  },
} as const satisfies OptionsMap

export type CardScheme = ExtractValue<
  typeof CARD_SCHEMES_MAP
>

const _options = buildOptionsFromMap(CARD_SCHEMES_MAP)

export const useCardSchemeOptions = () => {
  return {
    options: _options,
    getLabelForValue: (value: CardScheme) =>
      _options.find((option) => option.value === value)
        ?.label || "",
  }
}
